var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 3.21429H18.2143V2.14286C18.2143 1.57454 17.9885 1.02949 17.5867 0.627628C17.1848 0.225765 16.6398 0 16.0714 0H7.5C6.93168 0 6.38664 0.225765 5.98477 0.627628C5.58291 1.02949 5.35714 1.57454 5.35714 2.14286V3.21429H2.14286C1.57454 3.21429 1.02949 3.44005 0.627628 3.84191C0.225765 4.24378 0 4.78882 0 5.35714V27.8571C0 28.4255 0.225765 28.9705 0.627628 29.3724C1.02949 29.7742 1.57454 30 2.14286 30H21.4286C21.9969 30 22.5419 29.7742 22.9438 29.3724C23.3457 28.9705 23.5714 28.4255 23.5714 27.8571V5.35714C23.5714 4.78882 23.3457 4.24378 22.9438 3.84191C22.5419 3.44005 21.9969 3.21429 21.4286 3.21429ZM7.5 2.14286H16.0714V6.42857H7.5V2.14286ZM21.4286 27.8571H2.14286V5.35714H5.35714V8.57143H18.2143V5.35714H21.4286V27.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.cf3b3c29a95a4077326cfee5dfa4ab20.svg";
export { ForwardRef as ReactComponent };